export const alertMessages = {
    loginValidationError: "Invalid email and password",
    requiredFields: "Please fill all required fields"
}
